// ToastProvider.jsx
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { registerToast } from "core/Operations/toast";
import PropTypes from "prop-types";
import { message } from "antd";

let id = 0;

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = (message, type, duration) => {
    console.log("Toast Type", type);
    const toastId = id++;
    setToasts((prev) => [...prev, { id: toastId, message, type }]);

    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== toastId));
    }, duration);
  };

  useEffect(() => {
    registerToast(showToast); 
  }, []);

  return (
    <>
      {children}
      {ReactDOM.createPortal(
        <div
          style={{ zIndex: 9999 }}
          className="toast-container position-fixed top-0 start-50 translate-middle-x p-3"
        >
          {toasts.map((t) => {
            const classNames = getClassNames(t.type);
            return (
              <div
                id="topcenter-Toast"
                key={t.id}
                className={classNames.className}
                role="alert"
              >
                <i className={classNames.icon} />
                &nbsp;
                <div>{t.message}</div>
              </div>
            );
          })}
        </div>,
        document.body
      )}
    </>
  );
};

ToastProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

const getClassNames = (type) => {
  switch (type) {
    case "success":
      return {
        className:
          "alert alert-solid-success d-flex align-items-center rounded-pill",
        icon: "feather-check-circle",
      };

    case "error":
      return {
        className:
          "alert alert-solid-danger d-flex align-items-center rounded-pill",
        icon: "feather-alert-octagon",
      };
    case "warning":
      return {
        className:
          "alert alert-solid-warning d-flex align-items-center rounded-pill",
        icon: "feather-alert-triangle",
      };
    case "info":
      return {
        className:
          "alert alert-solid-primary d-flex align-items-center rounded-pill",
        icon: "feather-info",
      };
    default:
      return {
        className:
          "alert alert-solid-primary d-flex align-items-center rounded-pill",
        icon: "feather-info",
      };
  }
};
const getColor = (type) => {
  switch (type) {
    case "success":
      return "#52c41a";
    case "error":
      return "#ff4d4f";
    case "warning":
      return "#faad14";
    case "info":
    default:
      return "#1890ff";
  }
};
